import React from "react";
import { RouteComponentProps } from "@reach/router";
import { ActivityContent } from "./activity-content";


interface Props {
  interestID: string;
}

const ActivityPage: React.FC<RouteComponentProps & Props> = (props) => (
  <ActivityContent
    interestID={props.interestID}
  />
);

export default ActivityPage;
